import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import CancelModal from '../../../components/Modals/cancelModal';
import Spinner from '../../../components/Spinner/Spinner';
import auth from '../../../helpers/auth';
import moment from 'moment';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import { setTimeLable } from '../../../helpers/checkSlots';
import AlertBox from '../../../components/AlertBox/AlertBox';
import config from '../../../config';
const localizer = momentLocalizer(moment);
const modaltext = 'Are you sure you want to delete this Appointment';

let values = [];
let targetData = [];
let last_page = 0;
let currentPage = 1;
let totalPage = [];

export class CAppointmentView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 'upcoming',
      showModal: false,
      session: false,
      events: [],
    };
    this.setTabState = this.setTabState.bind(this);
    this.setModal = this.setModal.bind(this);
    this.cancelBooking = this.cancelBooking.bind(this);
    this.showSessionModal = this.showSessionModal.bind(this);
    this.loadBookings = this.loadBookings.bind(this);
    this.prevPage = this.prevPage.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.changePage = this.changePage.bind(this);
    this.setPageClass = this.setPageClass.bind(this);
  }

  async setTabState(value) {
    let {
      upcomingAppointments,
      pastAppointments,
      todayAppointments,
      weekAppointments,
    } = this.props.CAppointmentState;

    this.setState({
      tab: value,
    });

    if (value === 'upcoming') {
      currentPage = upcomingAppointments.currentPage;
      await this.props.fetchUpcomingBookings(currentPage);
    } else if (value === 'past') {
      currentPage = pastAppointments.currentPage;
      await this.props.fetchPastBookings(currentPage);
    } else if (value === 'week') {
      currentPage = weekAppointments.currentPage;
      await this.props.fetchWeekBookings(currentPage);
    } else if (value === 'today') {
      currentPage = todayAppointments.currentPage;
      await this.props.fetchTodayBookings(currentPage);
    } else if (value === 'ongoing') {
      await this.props.fetchTodayBookings(-1);
    }
  }

  showSessionModal(value) {
    this.setState({
      session: value,
    });
  }

  setModal(value) {
    this.setState({ showModal: value });
  }

  async cancelBooking(Id) {
    await this.props.CancelAppointment(Id, currentPage);
    this.setState({ showModal: false });
  }

  setSessionCancel(item) {
    let {
      counsellor_timezone_slot,
      package: { session_hours, session_minutes },
      booking_date,
    } = item;

    var x = false;
    let bookingDate = booking_date.split('-'); // removing dashes from the date
    var d = new Date(
      bookingDate[0] +
        ' ' +
        bookingDate[1] +
        ' ' +
        bookingDate[2] +
        ',' +
        counsellor_timezone_slot
    );
    var startTime = new Date(d.getTime() - 10 * 60000);
    var startTime1 = new Date(
      bookingDate[0] +
        ' ' +
        bookingDate[1] +
        ' ' +
        bookingDate[2] +
        ',' +
        counsellor_timezone_slot
    );
    var startTimeHour = startTime.getHours();
    var startTimeMinute = startTime.getMinutes();
    if (startTimeMinute / 2 < 5) {
      var NewStartTime = parseInt(
        startTimeHour + '' + 0 + '' + startTimeMinute
      );
    } else {
      var NewStartTime = parseInt(startTimeHour + '' + startTimeMinute);
    }
    var time = +session_hours * 60 + +session_minutes;
    var endTime = new Date(
      startTime1.setMinutes(startTime1.getMinutes() + time)
    );
    var endTimeHour = endTime.getHours();
    var endTimeMinute = endTime.getMinutes();

    if (endTimeMinute / 2 < 5) {
      var NewEndTime = parseInt(endTimeHour + '' + 0 + '' + endTimeMinute);
    } else {
      var NewEndTime = parseInt(endTimeHour + '' + endTimeMinute);
    }

    var currentDate = new Date();
    var currentDateHour = currentDate.getHours();
    var currentDateMinute = currentDate.getMinutes();
    if (currentDateMinute / 2 < 5) {
      var NewCurrentTime = parseInt(
        currentDateHour + '' + 0 + '' + currentDateMinute
      );
    } else {
      var NewCurrentTime = parseInt(currentDateHour + '' + currentDateMinute);
    }
    if (
      NewCurrentTime >= NewStartTime &&
      NewCurrentTime <= NewEndTime &&
      currentDate.getUTCDate() == startTime.getUTCDate() &&
      currentDate.getFullYear() == startTime.getFullYear()
    ) {
      x = true;
    } else {
      x = false;
    }
    return x;
  }
  isCompleted(item) {
    let {
      package: { session_hours, session_minutes },
    } = item;
    let minutes = +session_hours * 60 + +session_minutes;
    let startTime = new Date(
      item.booking_date.split('-')[0] +
        ' ' +
        item.booking_date.split('-')[1] +
        ' ' +
        item.booking_date.split('-')[2] +
        ',' +
        item.counsellor_timezone_slot
    );
    let endTime = new Date(startTime.getTime() + minutes * 60000);
    if (endTime < new Date()) {
      return true;
    } else {
      return false;
    }
  }
  async componentDidMount() {
    document.addEventListener('keyup', (e) => {
      if (e.keyCode === 27) {
        this.setModal(false);
      }
    });
    this.loadBookings();
    await this.props.fetchUpcomingBookings(currentPage);
    await this.props.fetchPastBookings(currentPage);
    await this.props.fetchTodayBookings(currentPage);
    await this.props.fetchWeekBookings(currentPage);
    this.sessionBtn = this.sessionBtn.bind(this);
    this.startVideoSession = this.startVideoSession.bind(this);
    await this.props.setMenuHover('bookings');
    let body = document.body;
    body.className = 'cons__booking dashboard_bookings';
  }

  // componentWillUnmount() {
  //   // fix Warning: Can't perform a React state update on an unmounted component
  //   this.setState = (state, callback) => {
  //     return;
  //   };
  // }

  async loadBookings() {
    const token = auth.getAccessToken();
    this.setState({ loadingSpinner: true });
    if (token) {
      try {
        let result = await fetch(`${config.__API__}/get/all/bookings`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ` + token,
          },
        });
        let response = await result.json();
        if (!response.success) {
          this.setState({ loadingSpinner: false });
        } else if (response.success) {
          this.setState({ bookings: response.bookings, loadingSpinner: false });
        }
      } catch (e) {
        console.log(e);
      }
    }

    //---> modifying the response to set in this.state.events in array format
    let { bookings } = this.state;
    if (bookings !== undefined) {
      for (let i = 0; i < bookings.length; i++) {
        let temp = {};
        let duration =
          +bookings[i].package.session_hours * 60 +
          +bookings[i].package.session_minutes;
        let bookingDate = bookings[i].booking_date.split('-'); // removing dashes from the date
        let value = new Date(
          bookingDate[0] +
            ' ' +
            bookingDate[1] +
            ' ' +
            bookingDate[2] +
            ',' +
            bookings[i].slot
        );
        let endvalue = new Date(value.getTime() + duration * 60000);
        temp = Object.assign(
          temp,
          { start: value },
          { end: endvalue },
          { title: bookings && bookings[i].user && `${bookings[i].user.name}` }
        );
        if (
          values.length !== bookings.length &&
          values.length <= bookings.length
        ) {
          values.push(temp);
        }
      }
      this.setState({ events: values });
    }
  }

  sessionBtn(item) {
    var x = false;
    let {
      slot,
      package: { session_minutes, session_hours },
      booking_date,
    } = item;
    let bookingDate = booking_date.split('-'); // removing dashes from the date
    var d = new Date(
      bookingDate[0] + ' ' + bookingDate[1] + ' ' + bookingDate[2] + ',' + slot
    );
    var startTime = new Date(d.getTime() - 5 * 60000);
    var startTime1 = new Date(
      bookingDate[0] +
        ' ' +
        bookingDate[1] +
        ' ' +
        bookingDate[2] +
        ',' +
        item.slot
    );
    var startTimeHour = startTime.getHours();
    var startTimeMinute = startTime.getMinutes();
    if (startTimeMinute / 2 < 5) {
      var NewStartTime = parseInt(
        startTimeHour + '' + 0 + '' + startTimeMinute
      );
    } else {
      var NewStartTime = parseInt(startTimeHour + '' + startTimeMinute);
    }
    var time = +session_hours * 60 + +session_minutes;
    var endTime = new Date(
      startTime1.setMinutes(startTime1.getMinutes() + time)
    );
    var endTimeHour = endTime.getHours();
    var endTimeMinute = endTime.getMinutes();

    if (endTimeMinute / 2 < 5) {
      var NewEndTime = parseInt(endTimeHour + '' + 0 + '' + endTimeMinute);
    } else {
      var NewEndTime = parseInt(endTimeHour + '' + endTimeMinute);
    }

    var currentDate = new Date();
    var currentDateHour = currentDate.getHours();
    var currentDateMinute = currentDate.getMinutes();
    if (currentDateMinute / 2 < 5) {
      var NewCurrentTime = parseInt(
        currentDateHour + '' + 0 + '' + currentDateMinute
      );
    } else {
      var NewCurrentTime = parseInt(currentDateHour + '' + currentDateMinute);
    }
    if (
      NewCurrentTime >= NewStartTime &&
      NewCurrentTime <= NewEndTime &&
      currentDate.getUTCDate() == startTime.getUTCDate() &&
      currentDate.getFullYear() == startTime.getFullYear()
    ) {
      x = true;
    } else {
      x = false;
    }
    return x;
  }

  startVideoSession(item) {
    let {
      package: { session_hours, session_minutes },
      counsellor,
      user,
    } = item;
    let { sessionData } = this.props.selectState;
    sessionData['from_id'] = counsellor.id;
    sessionData['to_id'] = user.id;
    sessionData['session_hours'] = session_hours;
    sessionData['session_minutes'] = session_minutes;
    sessionData['booking_id'] = item.id;
    sessionData['username'] = counsellor.name;
    sessionData['slot'] = item.slot;
    this.props.saveSessionData(sessionData);

    if (this.sessionBtn(item)) {
      this.props.history.push('/coach/dashboard/new_session');
    }
  }

  async prevPage(e) {
    let { tab } = this.state;
    let num = (await parseInt(currentPage)) - 1;
    if (currentPage > 1) {
      currentPage = num;
      if (tab === 'upcoming') {
        await this.props.fetchUpcomingBookings(currentPage);
      } else if (tab === 'past') {
        await this.props.fetchPastBookings(currentPage);
      } else if (tab === 'week') {
        await this.props.fetchWeekBookings(currentPage);
      } else if (tab === 'today') {
        await this.props.fetchTodayBookings(currentPage);
      }
    }
  }

  async nextPage() {
    let { tab } = this.state;
    let num = (await parseInt(currentPage)) + 1;
    if (currentPage < last_page) currentPage = num;
    if (tab === 'upcoming') {
      await this.props.fetchUpcomingBookings(currentPage);
    } else if (tab === 'past') {
      await this.props.fetchPastBookings(currentPage);
    } else if (tab === 'week') {
      await this.props.fetchWeekBookings(currentPage);
    } else if (tab === 'today') {
      await this.props.fetchTodayBookings(currentPage);
    }
  }

  async changePage(e) {
    let { tab } = this.state;
    let value = await e.target.name;
    currentPage = value;
    // await this.props.fetchBooking(currentPage);
    if (tab === 'upcoming') {
      await this.props.fetchUpcomingBookings(currentPage);
    } else if (tab === 'past') {
      await this.props.fetchPastBookings(currentPage);
    } else if (tab === 'week') {
      await this.props.fetchWeekBookings(currentPage);
    } else if (tab === 'today') {
      await this.props.fetchTodayBookings(currentPage);
    }
  }

  setPageClass(value) {
    if (value === currentPage) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    let { tab } = this.state;
    let {
      spinner,
      todayAppointments,
      weekAppointments,
      pastAppointments,
      upcomingAppointments,
      ongoingAppointments,
      errMessage,
    } = this.props.CAppointmentState;

    if (tab == 'upcoming') {
      targetData = upcomingAppointments.data;
      currentPage = upcomingAppointments.currentPage;
      last_page = upcomingAppointments.last_page;
      totalPage = upcomingAppointments.totalPage;
    } else if (tab === 'past') {
      targetData = pastAppointments.data;
      currentPage = pastAppointments.currentPage;
      last_page = pastAppointments.last_page;
      totalPage = pastAppointments.totalPage;
    } else if (tab === 'today') {
      targetData = todayAppointments.data;
      currentPage = todayAppointments.currentPage;
      last_page = todayAppointments.last_page;
      totalPage = todayAppointments.totalPage;
    } else if (tab === 'week') {
      targetData = weekAppointments.data;
      currentPage = weekAppointments.currentPage;
      last_page = weekAppointments.last_page;
      totalPage = weekAppointments.totalPage;
    } else if (tab === 'ongoing') {
      targetData = ongoingAppointments.data;
      currentPage = ongoingAppointments.currentPage;
      last_page = ongoingAppointments.last_page;
      totalPage = ongoingAppointments.totalPage;
    } else if (tab === 'calendar') {
      targetData = [];
      last_page = 0;
      currentPage = 1;
      totalPage = [];
    }

    return (
      <Fragment>
        {errMessage && errMessage.message ? (
          <AlertBox AlertText={errMessage.message} color={errMessage.color} />
        ) : null}
        <div className="main-content">
          <div className="site__content">
            {this.state.showModal ? (
              <CancelModal
                cancelEvent={() => this.setModal(false)}
                actionEvent={() => this.cancelBooking(this.state.bookingId)}
                warningText={modaltext}
                actionText={'Cancel Appointment'}
                cancelText={'Discard'}
                // warningText={
                //   "Are you sure you want to cancel this Appointment ?"
                // }
              />
            ) : null}
            <div className="page__content">
              <div className="form__heading">
                <h3>
                  Booked <span>Appointments</span>
                </h3>
              </div>
              <div className="middle__content">
                <div className="tabs__wrapper">
                  <div className="tabs">
                    <ul className="tab_lists">
                      <li
                        className={
                          tab === 'upcoming' ? 'ui-tabs-active' : 'ui-tabs'
                        }
                      >
                        <Link
                          to="#"
                          onClick={() => this.setTabState('upcoming')}
                        >
                          Upcoming Appointments
                        </Link>
                      </li>
                      <li
                        className={
                          tab === 'past' ? 'ui-tabs-active' : 'ui-tabs'
                        }
                      >
                        <Link to="#" onClick={() => this.setTabState('past')}>
                          Past Appointments
                        </Link>
                      </li>
                    </ul>
                  </div>
                  {tab === 'upcoming' ||
                  tab === 'today' ||
                  tab === 'week' ||
                  tab === 'ongoing' ||
                  tab === 'calendar' ? (
                    <div className="filter_tabs">
                      <ul className="filter_lists">
                        <li
                          className={
                            tab === 'ongoing'
                              ? 'active_filter ongoing_filter'
                              : 'ongoing_filter'
                          }
                        >
                          <Link
                            to="#"
                            onClick={() => this.setTabState('ongoing')}
                          >
                            On-Going
                          </Link>
                        </li>
                        <li
                          className={
                            tab === 'today'
                              ? 'active_filter day_filter'
                              : 'day_filter'
                          }
                        >
                          <Link
                            to="#"
                            onClick={() => this.setTabState('today')}
                          >
                            Today
                          </Link>
                        </li>
                        <li
                          className={
                            tab === 'week'
                              ? 'active_filter week_filter'
                              : 'week_filter'
                          }
                        >
                          <Link to="#" onClick={() => this.setTabState('week')}>
                            Week
                          </Link>
                        </li>
                        <li
                          className={
                            tab === 'calendar'
                              ? 'active_filter calendar_filter'
                              : 'calendar_filter'
                          }
                        >
                          <Link
                            to="#"
                            onClick={() => this.setTabState('calendar')}
                          >
                            Calendar
                          </Link>
                        </li>
                      </ul>
                    </div>
                  ) : null}
                </div>
                {tab !== 'calendar' ? (
                  spinner ? (
                    <Spinner text={'Fetching details...'} />
                  ) : targetData.length == 0 ? (
                    <h3 className="text-center">No Appointments</h3>
                  ) : (
                    <ul className="o-lists">
                      {targetData.map(
                        (item, i) =>
                          item.counsellor &&
                          item.listing &&
                          item.user && (
                            <li className="list-item booking_list" key={i}>
                              <div className="booking_detail">
                                <div className="left_detail">
                                  <span className="patient_name">
                                    {item.user.name}
                                  </span>
                                  <span className="booking_day">
                                    slot: {item.slot.toLowerCase()}
                                  </span>
                                  <span className="booking_day text-blue-900">
                                    Package: {item.package.package_name}
                                  </span>
                                </div>
                                <div className="right_detail">
                                  <span className="last_booking">
                                    Appointment Date:{' '}
                                    <span>{item.booking_date}</span>
                                  </span>
                                  <span className="location">
                                    Duration:{' '}
                                    <span>
                                      {item.package.session_hours}
                                      {':'}
                                      {item.package.session_minutes}
                                    </span>{' '}
                                    {setTimeLable(
                                      item.package.session_hours,
                                      item.package.session_minutes
                                    )
                                      ? 'Minutes'
                                      : 'Hours'}
                                  </span>
                                  <span className="location">
                                    Amount:{' '}
                                    <span>
                                      {'$'}
                                      {item.package.amount}
                                    </span>{' '}
                                  </span>
                                </div>
                              </div>
                              <div className="booking_options flex md:justify-end">
                                <div className="video_session session_confirmation">
                                  {this.sessionBtn(item) ? (
                                    <Link
                                      to="#"
                                      className="active text-white"
                                      onClick={() =>
                                        this.startVideoSession(item)
                                      }
                                    >
                                      Start-Session
                                    </Link>
                                  ) : (
                                    <Link to="#" className="confirm-disable">
                                      {tab === 'past'
                                        ? 'Completed'
                                        : 'Confirmed'}
                                    </Link>
                                  )}
                                  {tab === 'past' ? null : (
                                    <Link
                                      to="#"
                                      // className={
                                      //   tab === "upcoming"
                                      //     ? "cancel"
                                      //     : "cancel-disable"
                                      // }
                                      className={
                                        this.isCompleted(item) ||
                                        this.setSessionCancel(item)
                                          ? 'cancel-disable'
                                          : 'disable'
                                      }
                                      onClick={() => {
                                        this.setModal(true);
                                        this.setState({ bookingId: item.id });
                                      }}
                                    >
                                      Cancel
                                    </Link>
                                  )}
                                </div>
                              </div>
                            </li>
                          )
                      )}
                    </ul>
                  )
                ) : null}
                {tab === 'calendar' ? (
                  <Fragment>
                    <div className="app_new--section">
                      <div className="help__block">
                        <div className="page_title text-center">
                          <h1 className="text-xl">
                            <span className="text_nav_blue">Information</span>
                          </h1>
                        </div>
                        <div className="help__text">
                          <p>
                            It’s simple, we made it quick and easy to find the
                            help you need. Click Here to search for coaches.
                          </p>
                          <p>
                            Once you have found your coach click ‘book
                            appointment’, create an account (using your time
                            zone), book your session, and pay. On the day of
                            your session, log in and have the session! You can
                            be anonymous if you choose, just use a pseudonym
                            (like an author)!
                          </p>
                          <p>
                            We will check your details and make your listing
                            live when approved. Connect your Stripe account,
                            Google Calendar if you choose, and add your
                            availability, and that’s it, simple! We can always
                            help you with your listing, Click Here to contact u
                          </p>
                        </div>
                      </div>
                      <div className="app_new--calendar">
                        <Calendar
                          localizer={localizer}
                          defaultDate={new Date()}
                          defaultView="month"
                          events={this.state.events}
                          style={{ height: '100vh' }}
                          tooltipAccessor={'Ibyte infomatics'}
                          views={['month', 'day', 'week']}
                        />
                      </div>
                    </div>
                  </Fragment>
                ) : null}
                {/* Paginations */}

                {targetData.length == 0 ||
                last_page == 1 ||
                tab === 'ongoing' ? null : (
                  <div className="site_pagination">
                    <ul>
                      <li className={currentPage > 1 ? 'prev' : 'disable'}>
                        <Link to="#" onClick={this.prevPage}>
                          &lt; Prev{' '}
                        </Link>
                      </li>
                      {totalPage.map((number, i) => {
                        return (
                          <li className="prev" key={i}>
                            <Link
                              to="#"
                              className={
                                this.setPageClass(number + 1)
                                  ? 'bg-blue-900 text-white'
                                  : ''
                              }
                              name={number + 1}
                              onClick={this.changePage}
                            >
                              {number + 1}
                            </Link>
                          </li>
                        );
                      })}
                      <li
                        className={currentPage < last_page ? 'next' : 'disable'}
                      >
                        <Link to="#" onClick={this.nextPage}>
                          Next &gt;{' '}
                        </Link>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default CAppointmentView;



// WEBPACK FOOTER //
// ./src/routes/CAppointments/components/CAppointmentView.js